module.exports = __webpack_public_path__ + "img/th_70mm_Scalps.356756df.jpg";